import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'lib-flexible'

Vue.config.productionTip = false

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)


Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
  // 路由守卫
  if (/www./g.test(to.path)) {
    window.open("http://" + to.path.slice(to.path.indexOf('www.')))
    next(false)
  } else if (/http:/g.test(to.path)) {
    window.open("http://" + to.path.slice(to.path.indexOf('http:')))
    next(false)
  } else if (/https:/g.test(to.path)) {
    window.open("https://" + to.path.slice(to.path.indexOf('https:')))
    next(false)
  } else {
    next()
  }
})

// import uCharts from '@qiun/ucharts'
// Vue.use(uCharts)
// var ucharts = require("@qiun/ucharts")

import * as echarts from 'echarts'// 在import的后面，echarts的前面加一个 * as
Vue.prototype.$echarts = echarts
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
